export const CHAR_CODE = {
  SPACE: 32,
  ENTER: 13,
};
